(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["canvia-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('canvia-mobile-buy-bar')) {
    customElements.define('canvia-mobile-buy-bar', class extends HTMLElement {
      connectedCallback() {
        this.explicitRequired = this.dataset.explicitRequired === 'true';
        this.productInfo = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        this.button = this.querySelector('[data-canvia-mobile-submit]');
        this.price = this.querySelector('[data-canvia-mobile-price]');
        this.onChange = this.handleChange.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.productInfo?.addEventListener('change', this.onChange);
        this.installObserver();
        this.applyExplicitGuard();
        this.sync();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.productInfo?.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }

      nativeButton() {
        return document.getElementById(this.dataset.submitId);
      }

      variantPicker() {
        return this.productInfo?.querySelector('variant-selects');
      }

      installObserver() {
        const nativeButton = this.nativeButton();
        if (!nativeButton) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting;
        }, { threshold: 0.15 });
        this.observer.observe(nativeButton);
      }

      applyExplicitGuard() {
        if (!this.explicitRequired) return;
        const nativeButton = this.nativeButton();
        if (nativeButton) nativeButton.disabled = true;
        this.productInfo.dataset.canviaExplicitVariant = 'true';
        this.productInfo.querySelectorAll('[data-product-buy-now], .shopify-payment-button button').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        });
        const picker = this.variantPicker();
        if (picker && !picker.nextElementSibling?.classList.contains('canvia-explicit-variant-message')) {
          const message = document.createElement('p');
          message.className = 'canvia-explicit-variant-message';
          message.textContent = this.dataset.chooseMessage;
          message.setAttribute('role', 'status');
          picker.insertAdjacentElement('afterend', message);
        }
      }

      handleChange(event) {
        if (!event.target.closest('variant-selects')) return;
        this.explicitRequired = false;
        this.dataset.explicitRequired = 'false';
        this.productInfo.dataset.canviaExplicitVariant = 'false';
        this.productInfo?.querySelector('.canvia-explicit-variant-message')?.remove();
        window.setTimeout(() => this.sync(), 80);
      }

      handleClick() {
        if (this.explicitRequired) {
          this.variantPicker()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.variantPicker()?.querySelector('input, select')?.focus();
          return;
        }
        const nativeButton = this.nativeButton();
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
      }

      sync() {
        const nativeButton = this.nativeButton();
        const priceSource = document.querySelector(`#price-${CSS.escape(this.dataset.sectionId)} .price-item--regular, #price-${CSS.escape(this.dataset.sectionId)} .price-item--sale`);
        if (priceSource) this.price.textContent = priceSource.textContent.trim();
        this.button.disabled = !nativeButton || nativeButton.disabled && !this.explicitRequired;
        this.button.textContent = this.explicitRequired ? this.dataset.chooseLabel : this.dataset.addLabel;
        this.productInfo?.querySelectorAll('[data-product-buy-now], .shopify-payment-button button').forEach((button) => {
          button.disabled = this.explicitRequired || !nativeButton || nativeButton.disabled;
          button.setAttribute('aria-disabled', String(button.disabled));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
